export default __webpack_public_path__ + "061fda075295fe179542492d49b0c4c7.png";